module.exports = __webpack_public_path__ + "img/spotify.776f23ff.svg";